export default __webpack_public_path__ + "static/media/pressure-result.59381646.svg";